module.exports = __webpack_public_path__ + "static/img/icon tj wjj01.f77aeb54.svg";